// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"snackBar_snackBar__W8lex","action":"snackBar_action__5vkyV","whiteWithBlackText":"snackBar_whiteWithBlackText__bBMxo","purpleSnackbar":"snackBar_purpleSnackbar__qa2_m"};